module.exports = __webpack_public_path__ + "static/img/08.1a1c554.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/08.jpg
// module id = lLUU
// module chunks = 0